import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { MetaDataService } from '../metadata.service';
import { NGXLogger } from 'ngx-logger';
import { Subject, takeUntil } from 'rxjs';
import { NgStyle } from '@angular/common';
import { TruncatedMarkdownComponent } from '../truncated-markdown/truncated-markdown.component';
import { TeaItemSummaryComponent } from '../tea-item-summary/tea-item-summary.component';
import { TeaByFlavourResolverData } from './tea-by-flavour.resolver';

@Component({
    selector: 'tea-shop-fe-tea-by-flavour',
    templateUrl: './tea-by-flavour.component.html',
    styleUrls: ['./tea-by-flavour.component.css'],
    imports: [NgStyle, TruncatedMarkdownComponent, TeaItemSummaryComponent]
})
export class TeaByFlavourComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private metaDataService = inject(MetaDataService);
  private logger = inject(NGXLogger);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teaFlavour: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teas: any[] = [];
  errors: string[] = [];
  headerImageURL: string | null = null;
  private destroy$ = new Subject<void>();

  ngOnInit() {
    // Subscribe to route data changes instead of using snapshot
    this.route.data.pipe(
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      this.updateComponentData(data);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateComponentData(data: Data) {
    // Reset component state
    this.teaFlavour = null;
    this.teas = [];
    this.errors = [];
    this.headerImageURL = null;
    
    // Get the resolved data from the route
    const flavourData: TeaByFlavourResolverData = data['flavourData'];
    
    if (flavourData) {
      this.teaFlavour = flavourData.teaFlavour;
      this.teas = flavourData.teas;
      this.errors = flavourData.errors;
      this.headerImageURL = flavourData.headerImageURL;
      
      // Update metadata if tea flavour is available
      if (this.teaFlavour) {
        this.metaDataService.updateMetadata({
          title: `Teas with the ${this.teaFlavour.name} flavour - Sencha Tea`,
          image: `/assets/tea-type-lady/green-tea-lady.png`,
        });
      }
    } else {
      this.errors.push('Failed to load tea flavour data.');
    }
  }
}
